import POSType from "../types/POSType";

interface POSAction {
  type: string;
  payload?: any;
}

const initial_state = {
  sellerWiseProductList: [],
  cartList: [],
  totalQty: 0,
  totalTax: 0,
  totalAmount: 0,
  totalPV: 0,
  deliveryCharge: 0,
  productVariantDetails: [],
  productDetails: [],
};
const POSReducer = (state = initial_state, action: POSAction) => {
  switch (action.type) {
    case POSType.SET_SELLER_WISE_PRODUCT_LIST: {
      const { data, page } = action.payload;
      let newData = [];
      const prevData: any = [...state.sellerWiseProductList];
      console.log({ page });
      if (page > 0) {
        if (data.length > 0) {
          newData = [...prevData, ...data];
        } else {
          newData = [...prevData];
        }
      } else {
        newData = data;
      }

      return {
        ...state,
        sellerWiseProductList: newData,
      };
    }

    case POSType.SET_ADD_TO_CART:
      return {
        ...state,
      };

    case POSType.GET_CART_LIST:
      return {
        ...state,
        cartList: action.payload.data,
        totalQty: action.payload.totalQty,
        totalTax: action.payload.totalTax,
        totalAmount: action.payload.totalAmount,
        totalPV: action.payload.totalPV,
        deliveryCharge: action.payload.deliveryCharge,
      };

    case POSType.REMOVE_CART_ITEM:
      return {
        ...state,
      };

    case POSType.ORDER_GENERATES:
      return {
        ...state,
      };

    case POSType.REMOVE_ALL_ITEM:
      return {
        ...state,
      };

    case POSType.GET_PRODUCT_VARIANT_DETAILS:
      return {
        ...state,
        productVariantDetails: action.payload.data,
      };

    case POSType.GET_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: action.payload.data,
      };

    default:
      return state;
  }
};

export default POSReducer;
